import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single-policy", (props) => {
  return <ContentBlocks className="text-wrap" blocks={props.policy?.contentBlocks} />
})
